import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Personorg } from '../model/personorg';
import { Organization } from '../model/Organization';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';




@Injectable({
  providedIn: 'root'
})
export class PersonorglistService {
  personServiceUrl:string = environment.apiUrl+'/person/';
  
  constructor(private http:HttpClient) { }

  getPersonOrgs(personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json' 
      })
    }
    var getPersonOrgsUrl = this.personServiceUrl+personId+'/organization/list';
    var personOrgs = this.http.get<Personorg[]>(getPersonOrgsUrl,httpOptions);
    //console.log(personOrgs);
    return personOrgs;
  }
  leaveOrg(org:Personorg){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json' 
      })
    }
    var leaveOrgsUrl = this.personServiceUrl+org.personId+'/organization/'+org.organizationId+'/leave';
    //console.log('Leave url: '+leaveOrgsUrl);
    return this.http.patch<any>(leaveOrgsUrl,org,httpOptions);
  }
  requestRejoin(org:Personorg){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json' 
      })
    }
    //POST /person/{personId}/organization/{organizationId}/joiner
    var reqJoinUrl = this.personServiceUrl+org.personId+'/organization/'+org.organizationId+'/joiner';
    var body = JSON.stringify(org);
    //console.log('req url: '+reqJoinUrl);
    //console.log('body: '+body);
    return this.http.post(reqJoinUrl,body,httpOptions);
  }
  getOrgDetails(org:Personorg){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json' 
      })
    }
    return this.http.get<Organization>(environment.apiUrl+'/organization/'+org.organizationId,httpOptions);
  }
}
